<template>
  <div class="border rounded shadow bg-white h-100">
    <LmComponentLoading v-if="isLoading" />
    <div class="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
      <i class="mdi mdi-lock-clock" style="font-size: 1.5rem"></i>
      <h4 class="text-center m-0">Historial de Logueo</h4>
      <span class="clickable" @click="$emit('close')">
        <i class="mdi mdi-close" style="font-size: 1.5rem"></i>
      </span>
    </div>
    <div class="scroll">
      <a-timeline
        class="p-4"
        v-if="movements.items.length"
      >
        <a-timeline-item
          v-for="(m, index) of movements.items"
          :key="index"
        >
          <div class="datos d-flex flex-column mx-2">
            <span>
              <b-avatar
                class="my-2"
                size="2.6em"
                variant="primary"
                :src="m.avatar"
              ></b-avatar>
              <span class="mx-2"><strong>{{`${userFullName(m)}`}}</strong>{{` ${m.activity}`}}</span>
            </span>
            <span
              v-if="m.createdAt"
              class="font-weight-light my-1"
            >
              {{ m.createdAt }}
            </span>
            <a @click="showDetails(index)" class="link-primary">{{ m.show ? 'Ocultar detalle' : 'Ver detalle' }}</a>
            <div v-if="m.show" class="mt-2">
              <div class="mt-2"><strong>Agente:</strong> {{m.createdBy.userAgent}}</div>
              <div><strong>IP:</strong> {{m.createdBy.userIp}}</div>
            </div>
          </div>
        </a-timeline-item>
      </a-timeline>
    </div>
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import LmButton from '@/components/form/elements/LmButton'

export default {
  props: {
    serviceName: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      titulo: 'Auditoría',
      isLoading: false,
      movements: {
        items: []
      }
    }
  },
  components: {
    LmButton
  },
  methods: {
    emptyUserAvatar (m) {
      if (m.createdBy) {
        return m.createdBy?.user.firstname?.charAt(0) + m.createdBy?.user.lastname?.charAt(0)
      }
      return null
    },
    userFullName (m) {
      return `${m.createdBy?.user.firstname} ${m.createdBy?.user.lastname}`
    },
    showDetails (index) {
      if (!this.movements.items[index].show) {
        this.movements.items[index].show = true
      } else {
        this.movements.items[index].show = false
      }
      this.$forceUpdate()
    }
  },
  async created () {
    try {
      this.isLoading = true

      const historyResponse = await commonsApi.axiosGetWrapper(`/users/loghistory/${this.$route.params.id}`)

      this.movements.items = historyResponse.data || []
      this.movements.items = this.movements.items.map(item => {
        item.show = false
        return item
      })
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style lang="sass" scoped>
  .scroll
    height: calc(100% - 70px)
    overflow-y: auto
    &:hover
      &::-webkit-scrollbar-thumb
        border-radius: 20px
        background: #888
    &::-webkit-scrollbar
      width: 8px
    &::-webkit-scrollbar-thumb
      border-radius: 20px
      background: transparent
    &::-webkit-scrollbar-thumb:hover
      background: #555
</style>
